import * as types from "../constants";
const initialState = {
  isAuthenticated: false,
  currentUser: {},
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: true,
        currentUser: action.payload,
      };
    case types.LOGOUT_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: false,
        currentUser: {},
      };
    case types.SET_USER_AVATAR:
      return {
        ...state, currentUser :{ ...state.currentUser, avatar_url: action.avatar_url}
      }
    case types.SET_USER_TYPE:
      return {
        ...state,
        currentUser: { 
          ...state.currentUser, 
          user_type: action.payload.user_type, 
          active_mode: action.payload.active_mode 
        }
      }
    case types.SWITCH_ACTIVE_MODE:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          active_mode: action.payload.active_mode
        }
      }
    default:
      return state;
  }
};

export default authReducer;
